import * as Progress from "@radix-ui/react-progress";
import { useMemo } from "react";

function getUtilizationColorClass(percent: number): string {
  if (percent >= 90) return "bg-bg-helper-red-dark";
  if (percent >= 70) return "bg-bg-helper-yellow-dark";
  return "bg-bg-helper-green-dark";
}

interface UtilizationBarProps {
  used: number;
  max: number;
  currency?: string;
}

export const UtilizationBar: React.FC<UtilizationBarProps> = ({
  used,
  max,
  currency,
}) => {
  const percent = useMemo(
    () => (max > 0 ? Math.min((used / max) * 100, 100) : 0),
    [used, max],
  );
  const colorClass = getUtilizationColorClass(percent);

  return (
    <div className="w-full space-y-2">
      <Progress.Root
        value={percent}
        max={100}
        className="relative h-3 w-full overflow-hidden rounded-full bg-border-subtle"
        aria-label="Fiat limit utilization"
        aria-valuenow={Math.round(percent)}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <Progress.Indicator
          className={`h-full rounded-full ${colorClass}`}
          style={{ width: `${percent}%` }}
        />
      </Progress.Root>

      <div className="flex justify-between items-center text-xs text-text-subtle font-bold">
        <span>
          Used: {(used ?? 0).toLocaleString()} {currency}
        </span>
        <span>
          Max: {(max ?? 0).toLocaleString()} {currency}
        </span>
      </div>
    </div>
  );
};
